// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/IRANYekanX/Webfonts/woff/IRANYekanX-UltraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/IRANYekanX/Webfonts/woff2/IRANYekanX-UltraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/IRANYekanX/Webfonts/woff/IRANYekanX-DemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/IRANYekanX/Webfonts/woff2/IRANYekanX-DemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/IRANYekanX/Webfonts/woff/IRANYekanX-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/IRANYekanX/Webfonts/woff2/IRANYekanX-Medium.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: IRANYekanX;
  font-style: normal;
  font-weight: 200;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}
@font-face {
  font-family: IRANYekanX;
  font-style: normal;
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}
@font-face {
  font-family: IRANYekanX;
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
}
body {
  position: relative;
  font-family: "IRANYekanX" !important;
  padding: 0;
  margin: 0 auto;
}

* {
  box-sizing: border-box;
  font-family: IRANYekanX !important;
  font-feature-settings: "ss02";
  outline: none;
}
*::-webkit-scrollbar {
  background-color: #eee;
  width: 8px;
  height: 8px;
}
*::-webkit-scrollbar-thumb {
  background-color: #FF6B00;
  border-radius: 20px;
}

.flexCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.spaceBetween {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mainLoading {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadingContainer {
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-layout {
  --topbar-height:60px;
  --sidebar-width:236px;
  box-sizing: border-box;
  background-color: #27a057;
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 991px) {
  .main-layout {
    max-width: 100%;
  }
}

.scrollable-content {
  margin-top: var(--topbar-height);
  margin-right: var(--sidebar-width);
  width: calc(100% - var(--sidebar-width));
  height: calc(100vh - var(--topbar-height));
  overflow-y: auto;
  border-right: 3px solid #F4F7FB;
  background-color: white;
}
@media screen and (max-width: 1440px) {
  .scrollable-content {
    max-width: 100%;
    margin-right: 0;
    width: 100%;
  }
}

.appbar {
  position: fixed;
  top: 0;
  width: calc(100% - var(--sidebar-width));
  height: var(--topbar-height);
  margin-right: var(--sidebar-width);
  z-index: 100;
  border-bottom: 3px solid #F4F7FB;
  border-right: 3px solid #F4F7FB;
  background-color: white;
}
@media screen and (max-width: 1439px) {
  .appbar {
    margin-right: 0;
    max-width: 100%;
    width: 100%;
  }
}

.sidebar {
  position: fixed;
  top: 0;
  width: var(--sidebar-width);
  background-color: white;
  border-left: 3px solid #F4F7FB;
}
@media screen and (max-width: 1439px) {
  .sidebar {
    display: none;
  }
}

.mainError {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

[class*=MuiTableCell-root] [class*=MuiSvgIcon-root] {
  color: #FF6B00;
}

#chartjs-tooltip {
  z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/index.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;AACF;AAGA;EACE,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oHAAA;AADF;AAKA;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oHAAA;AAHF;AAOA;EACE,kBAAA;EACA,oCAAA;EACA,UAAA;EACA,cAAA;AALF;;AAQA;EACE,sBAAA;EACA,kCAAA;EAGA,6BAAA;EACA,aAAA;AALF;AAOE;EACE,sBAAA;EACA,UAAA;EACA,WAAA;AALJ;AAOE;EACE,yBAAA;EACA,mBAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AANF;;AAUA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAPF;;AAUA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAPF;AASE;EARF;IASI,eAAA;EANF;AACF;;AASA;EACE,gCAAA;EACA,kCAAA;EACA,wCAAA;EACA,0CAAA;EACA,gBAAA;EACA,+BAAA;EACA,uBAAA;AANF;AAQE;EATF;IAUI,eAAA;IACA,eAAA;IACA,WAAA;EALF;AACF;;AAQA;EACE,eAAA;EACA,MAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;EACA,uBAAA;AALF;AAOE;EAXF;IAYI,eAAA;IACA,eAAA;IACA,WAAA;EAJF;AACF;;AAOA;EACE,eAAA;EACA,MAAA;EACA,2BAAA;EACA,uBAAA;EACA,8BAAA;AAJF;AAME;EAPF;IAQI,aAAA;EAHF;AACF;;AAOA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAJF;;AASE;EACE,cAAA;AANJ;;AAWA;EACE,aAAA;AARF","sourcesContent":["@font-face {\n  font-family: IRANYekanX;\n  font-style: normal;\n  font-weight: 200;\n  src: url(../fonts/IRANYekanX/Webfonts/woff/IRANYekanX-UltraLight.woff) format('woff'),\n  url(../fonts/IRANYekanX/Webfonts/woff2/IRANYekanX-UltraLight.woff2) format('woff2');\n}\n\n@font-face {\n  font-family: IRANYekanX;\n  font-style: normal;\n  font-weight: bold;\n  src: url(../fonts/IRANYekanX/Webfonts/woff/IRANYekanX-DemiBold.woff) format('woff'),\n  url(../fonts/IRANYekanX/Webfonts/woff2/IRANYekanX-DemiBold.woff2) format('woff2');\n}\n\n@font-face {\n  font-family: IRANYekanX;\n  font-style: normal;\n  font-weight: normal;\n  src: url(../fonts/IRANYekanX/Webfonts/woff/IRANYekanX-Medium.woff) format('woff'),\n  url(../fonts/IRANYekanX/Webfonts/woff2/IRANYekanX-Medium.woff2) format('woff2');\n}\n\nbody {\n  position: relative;\n  font-family: \"IRANYekanX\" !important;\n  padding: 0;\n  margin: 0 auto;\n}\n\n* {\n  box-sizing: border-box;\n  font-family: IRANYekanX !important;\n  -moz-font-feature-settings: \"ss02\";\n  -webkit-font-feature-settings: \"ss02\";\n  font-feature-settings: \"ss02\";\n  outline: none;\n\n  &::-webkit-scrollbar{\n    background-color: #eee;\n    width: 8px;\n    height: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #FF6B00;\n    border-radius: 20px;\n  }\n}\n\n.flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.spaceBetween {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mainLoading {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loadingContainer {\n  width: 100%;\n  height: 80vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.main-layout {\n  --topbar-height:60px;\n  --sidebar-width:236px;\n  box-sizing: border-box;\n  background-color: #27a057;\n  width: 100%;\n  height: 100%;\n\n  @media screen and (max-width: 991px ) {\n    max-width: 100%;\n  }\n}\n\n.scrollable-content {\n  margin-top: var(--topbar-height);\n  margin-right: var(--sidebar-width);\n  width: calc(100% - var(--sidebar-width));\n  height: calc(100vh - var(--topbar-height));\n  overflow-y: auto;\n  border-right: 3px solid #F4F7FB;\n  background-color: white;\n\n  @media screen and (max-width: 1440px ) {\n    max-width: 100%;\n    margin-right: 0;\n    width: 100%;\n  }\n}\n\n.appbar {\n  position:fixed;\n  top:0;\n  width: calc(100% - var(--sidebar-width));\n  height: var(--topbar-height);\n  margin-right: var(--sidebar-width);\n  z-index: 100;\n  border-bottom: 3px solid #F4F7FB;\n  border-right: 3px solid #F4F7FB;\n  background-color: white;\n\n  @media screen and (max-width: 1439px ) {\n    margin-right: 0;\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n.sidebar {\n  position:fixed;\n  top: 0;\n  width: var(--sidebar-width);\n  background-color: white;\n  border-left: 3px solid #F4F7FB;\n\n  @media screen and (max-width: 1439px ) {\n    display: none;\n  }\n}\n\n\n.mainError {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n\n[class*='MuiTableCell-root'] {\n  [class*='MuiSvgIcon-root'] {\n    color: #FF6B00;\n  }\n}\n\n\n#chartjs-tooltip {\n  z-index: 9999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
